// extracted by mini-css-extract-plugin
module.exports = {"prices":"AdPrices_prices__3XqKP","originalPrice":"AdPrices_originalPrice__3o4ms","salePrice":"AdPrices_salePrice__1Qd8X"};